/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Title } from '@insticator/insticator-ui'; // iui-material
import Content from 'material/embeds/content/content_container';
import ControllerContainer from 'pages/dashboard/embeds/management/customize/controllercontainer/controllercontainer';
import ContentIndicator from 'material/embeds/contentindicator/contentindicator';
import Embed from 'material/embeds/embed/embed_container';
import NoContent from 'pages/dashboard/embeds/management/customize/nocontent/nocontent';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/customize/embededitor/embededitor_styles';



/* ========== ~~~~~~~~~~ EMBED EDITOR ~~~~~~~~~~ ========== */
class EmbedEditor extends Component {
    updateContentType = (type) => {
        if(type.toLowerCase() === this.props.contentType.toLowerCase())
           return;

        if (type === 'quiz' && this.props.questionFormat === 'emoji') {
            this.props.sendMessage(`We’re sorry, Quiz does not support emoji format. Please change the format first to make this a Quiz question.`)
        } else {
            this.props.setContentType(type);
        }

    };
    renderEmbed(){
        if(!this.props.contents || this.props.noLiveContents){
            return <NoContent contents={this.props.contents} />
        }
         return (
             <Embed isEditable={true} processClick={null} >
                <Content location={this.props.location === 'in-content' ? 'in-content' : 'rail'} contentId={this.props.selectedContent} isEditable={true} type={this.props.contentType} />
            </Embed>
         )
    }
    render() {
        const location = this.props.location === 'in-content' ? 'in-content' : 'rail';
        return(
            <div className={`embededitor ${this.props.classes.embededitor} ${location}` }>
                <ControllerContainer>
                    <Title>
                        {!this.props.contents || this.props.noLiveContents ? <h4> </h4> : <h4 className={`no-bold`}>Card {this.props.queuePosition} <span>/ {this.props.numberOfActiveContents}</span></h4>}
                        <ContentIndicator type={`select`} indicatorType={`select`} processClick={this.updateContentType} activeContents={[this.props.contentType]} disabled={!this.props.contents || this.props.noLiveContents} />{/* type = select, sort, key, indicator */}
                    </Title>
                    {this.renderEmbed()}
                </ControllerContainer>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EmbedEditor);
